import { round } from 'lodash';


export function convertToFahrenheit(value: number | string): number {return round(Number(value) * 1.8 + 32, 2);}
